import {Component} from '@angular/core';
import {AuthService} from './services/auth.service';
import {AuthHttpService} from "./services/auth-http.service";
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Globals} from './globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'SmartRoad';

  constructor(translate: TranslateService, private http: AuthHttpService, public Globals: Globals) {
    translate.addLangs(['en', 'ru', 'es']);
    translate.setDefaultLang('en');
    Globals.lang = 'en';
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|ru|es/) ? browserLang : 'en');
    Globals.lang = browserLang.match(/en|ru|es/) ? browserLang : 'en';

    // the lang to use, if the lang isn't available, it will use the current loader to get them
  }
}
